import { styled } from 'baseui'
import React from 'react'
import ThumbnailBorder from './ThumbnailBorder'
import ThumbnailContent from './ThumbnailContent'

export type ThumbnailCardSize = {
  width: number
  height: number
}

type ThumbnailCardProps = {
  imageSrc?: string | null
  videoUrl?: string | null
  selected: boolean
  isActive: boolean
  isLoading?: boolean
  /** Shows the GradientLoader as an overlay on top of the existing image/video. */
  loadingOverlay?: boolean
  isDisabled?: boolean
  size: ThumbnailCardSize
  width?: number
  height?: number
  renderContent?: boolean
  imageDraggable?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
  onContextMenu?: React.MouseEventHandler<HTMLDivElement>
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>
  onImageLoad?: React.ReactEventHandler<HTMLImageElement>
  onVideoLoad?: React.ReactEventHandler<HTMLVideoElement>
  /** Custom content inside the border, replacing the default image/video content. */
  content?: React.ReactNode
  children?: React.ReactNode
}

const Card = styled('div', (props: { $width?: number; $height?: number; $disabled?: boolean }) => ({
  position: 'relative',
  width: props.$width == null ? '100%' : `${props.$width}px`,
  height: props.$height == null ? '100%' : `${props.$height}px`,
  cursor: props.$disabled ? 'default' : 'pointer',
  borderRadius: '8px',
  pointerEvents: props.$disabled ? 'none' : 'auto',
}))

function ThumbnailCard({
  imageSrc,
  videoUrl,
  selected,
  isActive,
  isLoading = false,
  loadingOverlay = false,
  isDisabled = false,
  size,
  width,
  height,
  renderContent = true,
  imageDraggable,
  onClick,
  onContextMenu,
  onMouseEnter,
  onMouseLeave,
  onImageLoad,
  onVideoLoad,
  content,
  children,
}: ThumbnailCardProps) {
  return (
    <Card
      $width={width}
      $height={height}
      $disabled={isDisabled}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ThumbnailBorder selected={selected} isActive={isActive} isLoading={isLoading}>
        {content ?? (renderContent && (
          <ThumbnailContent
            preview={imageSrc}
            videoUrl={videoUrl}
            isDisabled={isDisabled}
            isLoading={isLoading}
            loadingOverlay={loadingOverlay}
            baseSize={size}
            draggable={imageDraggable}
            onImageLoad={onImageLoad}
            onVideoLoad={onVideoLoad}
          />
        ))}
      </ThumbnailBorder>
      {children}
    </Card>
  )
}

export default ThumbnailCard
